import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于91黑料视频的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-800 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0">Q</span>
                <span>{item.question}</span>
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed pl-8">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}